import { Edit, Create, SimpleForm, TextInput, NumberInput, SelectInput, DateTimeInput, useRecordContext } from 'react-admin';

const tallInput = { '& .MuiInputBase-root': { minHeight: 48 } };

const DiscountTitle = () => {
    const record = useRecordContext();
    return <span>{record ? record.name : ''}</span>;
};

export const DiscountEdit = () => (
    <Edit title={<DiscountTitle />}>
        <SimpleForm>
            <TextInput source="name" label="Название" fullWidth sx={tallInput} />
            <SelectInput source="type" label="Тип" choices={[
                { id: 'Percent', name: 'Процент (%)' },
                { id: 'Static', name: 'Фиксированная (₽)' },
            ]} fullWidth sx={tallInput} />
            <NumberInput source="value" label="Значение" sx={tallInput} />
            <DateTimeInput source="startDate" label="Начало" fullWidth sx={tallInput} />
            <DateTimeInput source="endDate" label="Конец" fullWidth sx={tallInput} />
        </SimpleForm>
    </Edit>
);

export const DiscountCreate = () => (
    <Create title="Новая скидка">
        <SimpleForm>
            <TextInput source="name" label="Название" fullWidth sx={tallInput} />
            <SelectInput source="type" label="Тип" choices={[
                { id: 'Percent', name: 'Процент (%)' },
                { id: 'Static', name: 'Фиксированная (₽)' },
            ]} fullWidth sx={tallInput} />
            <NumberInput source="value" label="Значение" sx={tallInput} />
            <DateTimeInput source="startDate" label="Начало" fullWidth sx={tallInput} />
            <DateTimeInput source="endDate" label="Конец" fullWidth sx={tallInput} />
        </SimpleForm>
    </Create>
);
